import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Carousel from '../../Carousel/Carousel';
import CarouselDots from '../../Carousel/CarouselDots/CarouselDots';
import PromoContentItem from '../../PromoContentItem/PromoContentItem';
import useStyles from '../../ProductGallery/ProductGalleryCarousel/ProductGalleryCarousel.styles';
import { useCarouselResponsive } from '../../../hooks/useCarouselResponsive';
const PromoContentGalleryCarousel = ({ items, halfWidth, itemHeadingTag, addDeliveryPassToCart, sendPromoContentGalleryAnalytics, }) => {
    const carouselRef = React.useRef(null);
    const { classes } = useStyles();
    const responsive = useCarouselResponsive();
    const getPromoItemKey = (item) => {
        var _a, _b, _c;
        const heading = typeof item.heading === 'string' ? item.heading : '';
        const message = typeof item.message === 'string' ? item.message : '';
        return [item.membershipProductSKU, (_a = item.link) === null || _a === void 0 ? void 0 : _a.id, (_b = item.link) === null || _b === void 0 ? void 0 : _b.url, (_c = item.image) === null || _c === void 0 ? void 0 : _c.url, heading, message]
            .filter(Boolean)
            .join('|');
    };
    const moveToNextSlide = () => {
        var _a;
        (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.next(1);
    };
    const moveToPreviousSlide = () => {
        var _a;
        (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.previous(1);
    };
    return (_jsx(Carousel, { containerClass: classes.carousel, sliderClass: classes.slider, responsive: responsive, arrows: false, autoPlay: false, itemClass: classes.carouselItem, ssr: true, showDots: true, renderDotsOutside: true, infinite: true, customDot: _jsx(CarouselDots, { itemsLength: items.length - 1, nextSlide: moveToNextSlide, prevSlide: moveToPreviousSlide, disableDotsClick: true }), ref: carouselRef, carouselContainerClass: classes.carouselContainer, children: items.map((item, index) => (_jsx(PromoContentItem, Object.assign({}, item, { itemIndex: index, halfWidth: halfWidth !== null && halfWidth !== void 0 ? halfWidth : undefined, headingTag: itemHeadingTag, addDeliveryPassToCart: addDeliveryPassToCart, sendPromoContentGalleryAnalytics: sendPromoContentGalleryAnalytics }), getPromoItemKey(item)))) }));
};
export default PromoContentGalleryCarousel;
